import React, { useState } from 'react'
import TotalSubscriberOneVolunteers from './child/TotalSubscriberOneVolunteers';
import TotalSubscriberOneVolunteer from './child/TotalSubscriberOneVolunteer';
import UsersOverviewOneVolunteer from './child/UsersOverviewOneVolunteer';
import MapComponentVolunteer from './child/MapComponentVolunteer';
import UnitCountOneVolunteer from './child/UnitCountOneVolunteer';
import ComplaintSourcesChartsModal from './child/ComplaintSourcesChartsModal';

const DashBoardLayerOneVolunteers = () => {
  const [showSourcesModal, setShowSourcesModal] = useState(false);

  return (
    <>
      {/* UnitCountOne */}
      <UnitCountOneVolunteer />




      <section className="row gy-4 mt-1">
       {/* TotalSubscriberOne */}
        <TotalSubscriberOneVolunteers />
        {/* TotalSubscriberOne */}
        <TotalSubscriberOneVolunteer />

        {/* UsersOverviewOne */}
        <UsersOverviewOneVolunteer />
        
        {/* MapComponent */}
        <MapComponentVolunteer />
 
       
      </section>

      {/* Complaint Sources Modal */}
      <ComplaintSourcesChartsModal 
        show={showSourcesModal} 
        handleClose={() => setShowSourcesModal(false)} 
      />
    </>
  )
}

export default DashBoardLayerOneVolunteers